import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { staffQueryKeys } from "./staffQueryKeys";

export function useStaffEnable({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (staffId: string) => {
      return (await api.staffApi.activate(staffId)).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: staffQueryKeys.all() });
    },
  });
}
